import { chatSelectors, useAppSelector } from '@vs-online-only-app/state';

export const useSelectedHeroConversation = () => {
  const selectedConversation = useAppSelector(
    chatSelectors.selectSelectedConversation
  );

  return selectedConversation;
};
